module.exports = __webpack_public_path__ + "static/step_1.d7543d56.png";